import React from 'react';
import './UbisoftPlusLoaderStyle.scss';

const UbisoftPLusLoader = () => {
  return (
    <div className="ubisoft_plus-loader">
      <div className="ubisoft_plus-loader_inner">
        <svg version="1.1" id="Ubisoft_x2B__x5F_Black" xmlns="http://www.w3.org/2000/svg"
             x="0px" y="0px" viewBox="0 0 1000 1000" >
          <g>
            <polygon points="595.87,384.79 595.87,42 364.85,42 364.85,384.79 277.11,384.79 277.11,384.75 22.1,384.75
              22.1,615.76 212.45,615.76 277.11,615.76 364.81,615.76 364.85,615.8 364.85,958.51 595.87,958.51 595.87,615.8 881.08,615.8
              978.14,384.79" />
          </g>
        </svg>
      </div>
    </div>
  );
};

export default UbisoftPLusLoader;
